module.exports = __webpack_public_path__ + "img/frame (4).4f54ed4a.jpg";